if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Debugging: Verify the form and its inputs
       // console.log('Form:', this.form);
      //  console.log('Form Elements:', this.form ? Array.from(this.form.elements).map(el => `${el.name}: ${el.value}`) : 'Form not found');
        
        // Get product ID from the form's hidden input
        const productIdInput = this.form ? this.form.querySelector('[name=product-id]') : null;
        this.productId = productIdInput ? productIdInput.value : 'Not found';
       // console.log('Product ID:', this.productId); // Debugging: Log the product ID
        
        // 检查是否有上传按钮
        this.hasImageUpload = Boolean(document.getElementById("custom-image-upload-1") || document.getElementById("custom-image-upload-2"));
       // console.log('Has image upload:', this.hasImageUpload); // Debugging: Log image upload presence
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('Form submitted'); // Debugging: Log form submission

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        // Debugging: Verify form elements and product ID in submit handler
        console.log('Form Elements on Submit:', Array.from(this.form.elements).map(el => `${el.name}: ${el.value}`));
        console.log('Product ID Check:', this.productId); // Debugging: Log product ID check

        // 根据是否存在图片上传按钮决定是否调用图片上传函数
        if (this.hasImageUpload) {
          console.log('Handling image upload for product ID:', this.productId); // Debugging: Log image upload handling
          this.handleImageUpload(evt); // 处理图片上传逻辑
        } else {
          console.log('Handling cart submission for other products', this.productId); // Debugging: Log cart submission handling
          this.handleCartSubmission(evt); // 对于没有图片上传功能的产品，执行默认的购物车提交操作
        }
      }

      // ADDITION: 处理图片上传逻辑的函数
      handleImageUpload(evt) {
        // 获取文件输入
        var fileInput1 = document.getElementById("custom-image-upload-1");
        var fileInput2 = document.getElementById("custom-image-upload-2");

        console.log('File Input 1:', fileInput1); // Debugging: Log file input 1
        console.log('File Input 2:', fileInput2); // Debugging: Log file input 2

        if (!fileInput1 || !fileInput2) {
          console.error("File inputs not found");
          return;
        }

        // 检查文件输入是否有文件
        if (!fileInput1.files.length && !fileInput2.files.length) {
          alert("Please upload at least one image.");
          return;
        }

        var formData = new FormData();
        if (fileInput1.files.length) formData.append("file1", fileInput1.files[0]);
        if (fileInput2.files.length) formData.append("file2", fileInput2.files[0]);

        console.log('FormData:', formData); // Debugging: Log FormData contents

        // 显示加载提示
        this.submitButtonText.textContent = "Uploading...";
        this.submitButton.setAttribute("aria-disabled", "true");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        // 上传文件到你的 API
        fetch("https://wx.0594mm.com/shopify_Upload2013.php", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            console.log('File upload response:', response); // Debugging: Log response
            return response.json();
          })
          .then((data) => {
            console.log('File upload data:', data); // Debugging: Log data from the file upload response

            if (!data.image1Url && !data.image2Url) {
              throw new Error("Invalid response from file upload API.");
            }

            var image1Url = data.image1Url ? data.image1Url.split('/').pop() : ''; // Get only the file name
            var image2Url = data.image2Url ? data.image2Url.split('/').pop() : ''; // Get only the file name

            // 添加图片 URL 作为属性到购物车表单
            this.addImagesToCartForm(image1Url, image2Url);
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            this.handleErrorMessage(
              "There was an error processing your request. Please try again."
            );
          })
          .finally(() => {
            // 隐藏加载提示
            this.submitButtonText.textContent = window.variantStrings.addToCart;
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      // ADDITION: 添加图片 URL 到购物车表单
      addImagesToCartForm(image1Url, image2Url) {
        console.log('Adding images to cart form:', image1Url, image2Url); // Debugging: Log image URLs

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (image1Url) formData.append("properties[custom.custom_image_1]", image1Url);
        if (image2Url) formData.append("properties[custom.custom_image_2]", image2Url);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Cart update response:', response); // Debugging: Log response

            if (response.status) {
              this.handleCartError(response);
              return;
            }

            this.handleCartSuccess(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.resetSubmitButton();
          });
      }

      // ADDITION: 处理默认购物车提交操作的函数
      handleCartSubmission(evt) {
        console.log('Handling cart submission'); // Debugging: Log cart submission handling

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Cart add response:', response); // Debugging: Log response

            if (response.status) {
              this.handleCartError(response);
              return;
            }

            this.handleCartSuccess(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.resetSubmitButton();
          });
      }

      handleCartError(response) {
        console.log('Handling cart error'); // Debugging: Log cart error handling
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: this.form.querySelector("[name=id]").value,
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage =
          this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButtonText.classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
        this.error = true;
      }

      handleCartSuccess(response) {
        console.log('Handling cart success'); // Debugging: Log cart success handling

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.form.querySelector("[name=id]").value,
            cartData: response,
          });

        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      resetSubmitButton() {
        console.log('Resetting submit button'); // Debugging: Log reset submit button

        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner").classList.add("hidden");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
